import * as React from 'react';

import { GraphContainer } from '../GraphContainer';
import { Graphs as GraphsComponent } from '../../../components/Graphs';

import { ILegend, TIndexTab } from '../../../types/redux';

export interface IGraphsProps {
  isVisible: boolean;
  legend: ILegend[];
  toggleGraphRegion(region: number): void;
  getGraphs(indexTab: TIndexTab): void;
}

export function Graphs(props: IGraphsProps) {
  const { isVisible, ...otherProps } = props;

  if (!isVisible) {
    return null;
  }

  return <GraphsComponent {...otherProps} graph={<GraphContainer />} />;
}
